<template>
  <div>
    <q-form ref="editForm">
      <c-card title="LBLBASEINFO" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn
              v-show="editable&&!disabled&&isOld"
              label="LBLREMOVE"
              icon="delete"
              @btnClicked="deleteInfo" />
            <c-btn
              v-show="editable&&!disabled"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="check"
              :mappingType="mappingType"
              label="LBLSAVEALL"
              icon="save"
              @beforeAction="saveInfo"
              @btnCallback="saveCallback" />
            <c-btn
              v-show="editable&&!disabled&&isOld"
              :url="completeUrl"
              :isSubmit="isComplete"
              :param="check"
              mappingType="PUT"
              label="LBLCOMPLETE"
              icon="check"
              @beforeAction="completeInfo"
              @btnCallback="completeCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <c-text
              :required="true"
              :disabled="disabled"
              :editable="editable"
              label="점검명"
              name="checkName"
              v-model="check.checkName">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
            <c-select
              :required="true"
              :disabled="disabled"
              :editable="editable"
              codeGroupCd="SOP_FIRE_FIGHTING_CHECK_TYPE_CD"
              type="edit"
              itemText="codeName"
              itemValue="code"
              label="점검유형"
              name="sopFireFightingCheckTypeCd"
              v-model="check.sopFireFightingCheckTypeCd"
            ></c-select>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
            <c-datepicker
              :required="true"
              :disabled="disabled"
              :editable="editable"
              range
              default="today"
              label="점검기간"
              name="period"
              v-model="check.period"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
            <c-plant
              :required="true"
              :disabled="disabled"
              :editable="editable"
              type="edit"
              name="plantCd"
              v-model="check.plantCd" />
          </div>
        </template>
      </c-card>
    </q-form>
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <c-table
          ref="table1"
          class="q-mt-sm"
          title="점검 대상"
          :columns="grid.columns"
          :data="check.targets"
          :gridHeight="gridHeight"
          :editable="editable&&!disabled"
          :filtering="false"
          :columnSetting="false"
          :isExcelDown="false"
          selection="multiple"
          rowKey="sopFireFightingCheckTargetId"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable&&!disabled" label="LBLEXCEPT" icon="delete" @btnClicked="deleteTarget" />
              <c-btn v-if="editable&&!disabled" label="LBLADD" icon="add" @btnClicked="addTarget" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name !== 'custom'">
              {{props.row[col.name]}}
              <div style="font-size:0.8em;">
                <template v-if="col.name==='sopFireFightingTypeName'">
                  ({{props.row['sopFireFightingKindName']}})
                </template>
                <template v-if="col.name==='fireFightingName'">
                  ({{props.row['manageNo']}})
                </template>
              </div>
            </template>
            <!-- <template v-else-if="col.name === 'custom'">
              <q-chip
                color="blue"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click.stop="rowClick(props.row)">
                ▶
              </q-chip>
            </template> -->
          </template>
        </c-table>
      </div>
        <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <c-table
          ref="table2"
          class="q-mt-sm"
          :title="select.sopFireFightingId ? `[${select.fireFightingName}] 점검항목` : '점검항목'"
          :columns="gridResult.columns"
          :data="select.results"
          :gridHeight="gridHeight"
          :editable="editable&&!disabled"
          :filtering="false"
          :columnSetting="false"
          :isExcelDown="false"
        >
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name==='customCol'">
              <component
                :is="imprComponent"
                :col="col"
                :props="props"
                :inputEditable="editable&&!disabled"
                :isImmShow="true"
                :requestContentsCols="requestContentsCols"
                tableKey="sopFireFightingCheckTargetResultId"
                ibmTaskTypeCd="ITT0000180"
                ibmTaskUnderTypeCd="ITTU000210"
                @imprChange="imprChange"
              />
            </template>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'fireFightingCheckInfo',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopFireFightingCheckId: '',
      }),
    },
    check: {
      type: Object,
      default: () => ({
        sopFireFightingCheckId: '',  // 소방설비 점검 일련번호
        plantCd: '',  // 사업장
        sopFireFightingCheckTypeCd: null,  // 점검유형
        checkName: '',  // 점검명
        sopFireFightingCheckStepCd: '',  // 점검진행상태
        checkStartDate: '',  // 점검시작일
        checkEndDate: '',  // 점검종료일
        period: [],
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        targets: [],
        deleteTargets: [],
        imprs: [],
      }),
    },
    select: {
      type: Object,
      default: () => ({
        sopFireFightingId: '',
        sopFireFightingKindCd: '',
        fireFightingName: '',
        editFlag: '',
        results: [],
      }),
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      colorItems: [],
      grid: {
        columns: [
          {
            name: 'sopFireFightingTypeName',
            field: 'sopFireFightingTypeName',
            label: '설비유형(종류)',
            align: 'center',
            sortable: false,
            style: 'width: 130px',
            type: 'custom',
          },
          {
            name: 'fireFightingName',
            field: 'fireFightingName',
            label: '소방설비(관리번호)',
            align: 'center',
            sortable: false,
            style: 'width: 130px',
            type: 'custom',
          },
          // {
          //   required: true,
          //   name: 'checkScheduleDate',
          //   field: 'checkScheduleDate',
          //   label: '점검예정일',
          //   style: 'width:100px',
          //   align: "center",
          //   sortable: false,
          //   type: 'date',
          //   value: '',
          //   setHeader: true,
          // },
          // {
          //   required: true,
          //   name: "deptName",
          //   field: "deptName",
          //   style: 'width:100px',
          //   label: "점검부서",
          //   align: "center",
          //   sortable: false,
          //   type: 'dept',
          //   deptCd: 'deptCd',
          //   value: '',
          //   setHeader: true,
          // },
          // {
          //   name: "checkDate",
          //   field: "checkDate",
          //   style: 'width:100px',
          //   label: "점검일",
          //   align: "center",
          //   sortable: false,
          //   type: 'date',
          //   value: '',
          //   setHeader: true,
          // },
          {
            name: "checkResult",
            field: "checkResult",
            style: 'width:350px',
            label: "점검결과",
            align: "center",
            sortable: false,
            type: 'text',
          },
          // {
          //   name: "custom",
          //   field: "custom",
          //   style: 'width:50px',
          //   label: "LBLITEMS",
          //   align: "center",
          //   sortable: false,
          //   type: 'custom',
          // },
        ],
      },
      gridResult: {
        columns: [
          {
            name: 'itemName',
            field: 'itemName',
            label: '점검항목',
            align: 'left',
            style: 'width:350px',
            sortable: false,
          },
          {
            name: 'sopFireFightingCheckResultCd',
            field: 'sopFireFightingCheckResultCd',
            label: '점검결과',
            align: 'center',
            style: 'width:150px',
            sortable: false,
            type: 'select',
            codeGroupCd: 'SOP_FIRE_FIGHTING_CHECK_RESULT_CD',
            value: '',
            setHeader: true,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: 'LBLREMARK',
            align: 'left',
            style: 'width:200px',
            sortable: false,
            type: 'textarea'
          },
          {
            name: 'customCol',
            field: 'customCol',
            label: '개선/진행상태',
            align: 'center',
            type: 'custom',
            sortable: false
          },
        ],
      },
      items: [],
      editable: false,
      isSave: false,
      isComplete: false,
      listItemUrl: '',
      saveUrl: '',
      deleteUrl: '',
      completeUrl: '',
      mappingType: 'PUT',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
      selectedRow: {},
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    gridHeight() {
      return this.contentHeight ? String(this.contentHeight - 250) + 'px' : '500px';
    },
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['itemName'];
    },
    // 개선요청 Component
    imprComponent() {
      let components = () => import(`${'@/pages/common/ibm/tableImpr.vue'}`);
      return components;
    },
  },
  watch: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
      //   this.colorItems = _result
      // });
      // url setting
      this.listItemUrl = selectConfig.sop.fft.base.item.list.url
      this.saveUrl = transactionConfig.sop.fft.fireFightingCheck.update.url
      this.deleteUrl = transactionConfig.sop.fft.fireFightingCheck.delete.url
      this.completeUrl = transactionConfig.sop.fft.fireFightingCheck.complete.url
      // code setting
      // list setting
      if (this.editable && !this.disabled) {
        this.getItems();
      }
    },
    getItems() {
      this.$http.url = this.listItemUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.check.plantCd,
        // sopFireFightingKindCd: row.sopFireFightingKindCd,
        useFlag: 'Y'
      }
      this.$http.request((_result) => {
        if (_result.data && _result.data.length > 0) {
          this.items = _result.data
        }
      },);
    },
    rowClick(row) {
      this.selectedRow = row;
      this.$set(this.select, 'sopFireFightingId', row.sopFireFightingId)
      this.$set(this.select, 'sopFireFightingKindCd', row.sopFireFightingKindCd)
      this.$set(this.select, 'fireFightingName', row.fireFightingName)
      this.$set(this.select, 'editFlag', row.editFlag)
      this.$set(this.select, 'results', row.results)
    },
    deleteTarget() {
      let selectData = this.$refs['table1'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.check.deleteTargets) this.check.deleteTargets = [];
        this.$_.forEach(selectData, item => {
          if (item.editFlag !== 'C'
            && this.$_.findIndex(this.check.deleteTargets, { sopFireFightingId: item.sopFireFightingId }) === -1) {
              this.check.deleteTargets.push(item)
            }
          this.check.targets = this.$_.reject(this.check.targets, item);
        })
        this.$refs['table1'].$refs['compo-table'].clearSelection();
        this.selectedRow = {};
      }
    },
    addTarget() {
      this.popupOptions.title = '소방설비 검색';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.check.plantCd
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/fft/fireFightingPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeFireFightingPopup;
    },
    closeFireFightingPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.check.targets, { sopFireFightingId: item.sopFireFightingId }) === -1) {
            let _sopFireFightingCheckTargetId = uid();
            let _results = [];
            this.$_.forEach(this.$_.filter(this.items, { 
              plantCd: item.plantCd, 
              sopFireFightingKindCd: item.sopFireFightingKindCd 
            }), _item => {
              _results.push({
                sopFireFightingCheckTargetResultId: uid(),  // 소방설비 점검결과 일련번호
                sopFireFightingCheckTargetId: _sopFireFightingCheckTargetId,  // 소방설비 점검대상 일련번호
                sopFireFightingCheckId: this.popupParam.sopFireFightingCheckId,  // 소방설비 점검 일련번호
                sopFireFightingCheckItemId: _item.sopFireFightingCheckItemId,  // 소방설비 점검항목 일련번호
                sopFireFightingTypeCd: _item.sopFireFightingTypeCd,
                sopFireFightingTypeName: _item.sopFireFightingTypeName,
                itemName: _item.itemName,
                sopFireFightingCheckResultCd: 'FFCR000001',  // 점검결과
                remarks: '',  // 비고
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                editFlag: 'C'
              })
            })
            this.check.targets.splice(0, 0, { 
              sopFireFightingCheckTargetId: _sopFireFightingCheckTargetId,  // 소방설비 점검대상 일련번호
              sopFireFightingCheckId: this.popupParam.sopFireFightingCheckId,  // 소방설비 점검 일련번호
              sopFireFightingId: item.sopFireFightingId,  // 소방설비 일련번호
              fireFightingName: item.fireFightingName,  // 소방설비 일련번호
              sopFireFightingTypeName: item.sopFireFightingTypeName,  // 소방설비 일련번호
              sopFireFightingKindName: item.sopFireFightingKindName,  // 소방설비 일련번호
              manageNo: item.manageNo,  // 소방설비 일련번호
              // deptCd: this.$store.getters.user.deptCd,  // 점검부서
              // checkScheduleDate: this.$comm.getToday(),  // 점검예정일
              // checkDate: '',  // 점검일
              checkResult: '',  // 점검결과
              results: _results,
              regUserId: this.$store.getters.user.userId,  // 등록자 ID
              editFlag: 'C'
            })
          }
        })
      }
    },
    saveInfo() {
      if (this.isOld) {
        this.saveUrl = transactionConfig.sop.fft.fireFightingCheck.update.url
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.fft.fireFightingCheck.insert.url
        this.mappingType = 'POST';
      }

      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.check.regUserId = this.$store.getters.user.userId;
              this.check.chgUserId = this.$store.getters.user.userId;
              this.$set(this.check, 'checkStartDate', this.check.period[0])
              this.$set(this.check, 'checkEndDate', this.check.period[1])

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$set(this.popupParam, 'sopFireFightingCheckId', result.data)
      this.$emit('getDetail');
    },
    deleteInfo() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.sopFireFightingCheckId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    completeInfo() {
      /**
       * 1. 점검대상이 하나 이상있는지?
       * 2. 점검대상에 점검일이 입력되어 있는지?
       */
      if (!this.check.targets || this.check.targets.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '점검대상이 없습니다.',
          type: 'warning', // success / info / warning / error
        });
        return;
      } 
      // else {
      //   let _filter = this.$_.filter(this.check.targets, (item) => {
      //     return !item.checkDate
      //   })
      //   if (_filter && _filter.length > 0) {
      //     window.getApp.$emit('ALERT', {
      //       title: 'LBLGUIDE', // 안내
      //       message: '점검일이 입력되지 않은 점검대상이 있습니다..',
      //       type: 'warning', // success / info / warning / error
      //     });
      //     return;
      //   }
      // }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGCOMPLETE', // 완료하시겠습니까?,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.check.regUserId = this.$store.getters.user.userId;
              this.check.chgUserId = this.$store.getters.user.userId;
              this.$set(this.check, 'checkStartDate', this.check.period[0])
              this.$set(this.check, 'checkEndDate', this.check.period[1])

              this.isComplete = !this.isComplete;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$set(this.popupParam, 'sopFireFightingCheckId', result.data)
      this.$emit('getDetail');
    },
    // 개선창 닫기 후
    imprChange() {
      // this.$emit('getDetail');
      // this.rowClick(this.selectedRow)
      this.$refs['table2'].$refs['compo-table'].resetVirtualScroll();
      this.$emit('getDetail');
    },
  }
};
</script>